// extracted by mini-css-extract-plugin
export default {"table_title":"styles_table_title__B5gu0","text_loading":"styles_text_loading__UnZRN"};